import { render, staticRenderFns } from "./tyres.vue?vue&type=template&id=73133c8c&scoped=true"
import script from "./tyres.vue?vue&type=script&lang=js"
export * from "./tyres.vue?vue&type=script&lang=js"
import style0 from "./tyres.vue?vue&type=style&index=0&id=73133c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73133c8c",
  null
  
)

export default component.exports